<template>
    <router-link tag="div" :to="'/restaurant/' + restaurant.id" class="rest_item" v-if="restaurant.show"  :key="restaurant.id"  :data-open="restaurant.open || restaurant.close">
        <div class="left">
            <div class="susi_logo">
                <img :src="restaurant.img" alt="">
            </div>
            <div class="left_column">
                <div class="title">
                    <h4>{{restaurant.name}}</h4>
                    <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                </div>
                <div class="stars">
                  <StarRating :rating="restaurant.rating" :read-only="true" :show-rating="false" :increment="0.01" active-color="gold"></StarRating>
                  <router-link :to="'/restaurant/' + restaurant.id + '/reviews'" class="stars_link">Отзывы</router-link>

                </div>
            </div>
        </div>
        <div class="right">
            <div class="first_line">
                <div class="title">
                    <h4>{{restaurant.name}}</h4>
                    <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                </div>
                <div class="icons">
                    <div class="icons_column">
                        <div class="icons_group">
                            <img :class="Object.values(restaurant.methods).includes(2)?'active':''" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/wallet.svg" alt="">
                            <img :class="Object.values(restaurant.methods).includes(3)?'active':''" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/credit_card.svg" alt="">
                            <img :class="restaurant.cashback?'active':''" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/pig.svg" alt="">
                            <img :class="Object.values(restaurant.methods).includes(4)?'active':''" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/gift.svg" alt="">
                            <img :class="Object.values(restaurant.methods).includes(41)?'active':''" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/pie.svg" alt="">
                        </div>

                        <div class="icon_descr" v-if="restaurant.cashback">
                            <p>cash-back {{restaurant.cashback}}%</p>
                        </div>
                        <div class="icon_descr" v-if="Object.values(restaurant.methods).includes(4)">
                            <p>оплата бонусами {{restaurant.bonus_payment_value}}%</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="second_line">
                <div class="min_price">
                    <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                        <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                    </div>
                    <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                        <p>Доставка {{restaurant.delivery_price}} руб.</p>
                    </div>
                    <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                        <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                    </div>
                    <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                        <p>бесплатная доставка</p>
                    </div>
                    <div class="column" >
                      <p>Доставим за {{restaurant.delivery_time}} мин</p>
                    </div>
                    <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                        <p>круглосуточно время работы</p>
                    </div>
                    <div class="column" v-else>
                        <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                    </div>
                </div>
            </div>
            <div class="third_line">
                <p>{{restaurant.desc}}</p>
            </div>
        </div>
        <div :class="restaurant.open === 'close' ? 'card_overlay active': 'card_overlay'" v-if="restaurant.city_id === city.id && auth.user_agent !== 'bot'">
            <div v-if="randomNumber() < 20">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/chef.png" alt="">
                <div class="card_col">
                    <h1>Этот ресторан <br> ещё не работает, листай дальше!</h1>
                    <p>Ждем гостей, жарим, варим парим ...</p>
                    <p>Ресторан закрыт.</p>
                </div>
            </div>
            <div v-else-if="randomNumber() < 40">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/chef2.png" alt="">
                <div class="card_col">
                    <h1>Этот ресторан <br> ещё не работает, листай дальше!</h1>
                    <p>В ресторане еще все спят :) Так бывает :)</p>
                    <p>Но скоро у нас можно будет заказать еду.</p>
                </div>
            </div>
            <div v-else-if="randomNumber() < 60">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/chef3.png" alt="">
                <div class="card_col">
                    <h1>Этот ресторан <br> ещё не работает, листай дальше!</h1>
                    <p>Мы скоро откроемся. Совсем скоро.</p>
                </div>
            </div>
            <div v-else-if="randomNumber() < 80">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/chef4.png" alt="">
                <div class="card_col">
                    <h1>Этот ресторан <br> ещё не работает, листай дальше!</h1>
                    <p>Скоро мы откроемся и начнем доставку</p>
                    <p>безумно вкусной еды.</p>
                </div>
            </div>
            <div v-else>
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/chef6.png" alt="">
                <div class="card_col">
                    <h1>Этот ресторан <br> ещё не работает, листай дальше!</h1>
                    <p>Немного терпения и мы снова откроемся.</p>
                </div>
            </div>
        </div>
        <div :class="city.id && restaurant.city_id !== city.id ? 'card_overlay active': 'card_overlay'" v-if="auth.user_agent !== 'bot'">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/chef.png" alt="">
            <div class="card_col">
                <h1>Этот ресторан <br> ещё не работает в вашем городе!</h1>
                <p>Ресторан закрыт.</p>
            </div>
        </div>
    </router-link>
</template>

<script>
import StarRating from 'vue-star-rating'
export default {
  name: 'restaurant',
  props: ['restaurant', 'city', 'auth'],
  components: {StarRating},
  methods: {
    randomNumber () {
      return Math.floor(Math.random() * (100 - 1 + 1)) + 1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/restaurant.vue